import {
  TRACKING_EVENT_ACTION,
  TRACKING_EVENT_CATEGORY,
  TRACKING_EVENT_NAME,
} from '@dh-io-otb/shared/src/models/constants';

import TrackingService from '@dh-io-otb/shared/src/services/tracking.service';
import { EventTrackingInfo } from '@dh-io-otb/shared/src/models/entities/tracking.model';

interface IUseMainHeader {
  trackShowFilters: () => void;
}

const useMainHeader = (): IUseMainHeader => {
  let eventHasBeenCalled = false;

  const trackShowFilters = () => {
    if (eventHasBeenCalled) return;
    eventHasBeenCalled = true;
    const event: EventTrackingInfo = {
      category: TRACKING_EVENT_CATEGORY.FEATURE,
      action: TRACKING_EVENT_ACTION.SHOW_FILTERS,
      name: TRACKING_EVENT_NAME.FEATURE,
    };
    TrackingService.trackEvent(event);
  };

  return { trackShowFilters };
};

export { useMainHeader };
